<template>
  <el-dialog :visible.sync="dialogVisible" :show-close="false"
    @close="dialogClose">
    <img
      class="close-img"
      src="@/assets/img/images/icon/close-icon.png"
      @click="dialogVisible = false"
    />
    <p class="p1">{{ title }}{{ $t('login.email') }}</p>
    <el-form
      class="mt20"
      :model="bindData"
      :rules="rules"
      ref="ruleFormEmailBind"
    >
      <el-form-item :label="$t('login.newemail')" prop="email">
        <el-input v-model="bindData.email"  :placeholder="$t('tipsVal.inputPlaceholder')" />
      </el-form-item>
      <el-form-item :label="$t('login.newemailcode')" prop="emailCode">
        <el-input v-model="bindData.emailCode"  :placeholder="$t('tipsVal.inputPlaceholder')">
          <template slot="append"
            ><span v-if="!emailCodeStatus.hasSend" @click="hasSendEmailCode">
              {{ $t("set_trade_password.getCode") }}</span
            >
            <span v-else>{{ emailCodeStatus.times }}</span></template
          >
        </el-input>
      </el-form-item>
      <el-form-item
        v-if="user.phoneSecurity === 1"
        :label="$t('google_bind.phone_code')"
        prop="phoneCode"
      >
        <el-input v-model="bindData.phoneCode"  :placeholder="$t('tipsVal.inputPlaceholder')">
          <template slot="append"
            ><span v-if="!phoneCodeStatus.hasSend" @click="hasSendPhoneCode">
              {{ $t("set_trade_password.getCode") }}</span
            >
            <span v-else>{{ phoneCodeStatus.times }}</span></template
          >
        </el-input>
      </el-form-item>

      <el-form-item
        v-if="user.googleSecurity === 1"
        prop="googleCode"
        :label="$t('googleBind.google_code')"
      >
        <el-input
          v-model="bindData.googleCode"
          maxlength="10"
          :placeholder="$t('email_bind.code_placeholder')"
        />
      </el-form-item>
    </el-form>
    <div class="btn-box">
      <div class="btn2" @click="submit">{{ $t('buy_box.confirm') }}</div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      title: this.$t("receipt_money.edit"),
      dialogVisible: false,
      bindData: {
        bindType: "email",
        email: "",
        phone: "",
        phoneToken: "",
        phoneCode: "",
        emailToken: "",
        emailCode: "",
        googleCode: "",
      },
      emailCodeSend: {
        email: "",
        phone: "",
        serviceName: "bind",
        verifyType: "email",
      },
      emailCodeStatus: {
        hasSend: false,
        times: 60,
      },
      phoneCodeSend: {
        serviceName: "bind",
        verifyType: "phone",
      },
      phoneCodeStatus: {
        hasSend: false,
        times: 60,
      },
      rules: {
        email: [
          {
            required: true,
            message: this.$t("validate.email_require"),
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$t("validate.email_formatter_error"),
            trigger: "blur",
          },
        ],
        phoneCode: [
          {
            required: true,
            message: this.$t("validate.mes_code_require"),
            trigger: "blur",
          },
        ],
        emailCode: [
          {
            required: true,
            message: this.$t("validate.email_code_require"),
            trigger: "blur",
          },
        ],
        googleCode: [
          {
            required: true,
            message: this.$t("validate.google_code_require"),
            trigger: "blur",
          },
        ],
      },
    };
  },

  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  methods: {
    hasSendPhoneCode() {
      this.phoneCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.phoneCodeStatus.times <= 0) {
          this.phoneCodeStatus.hasSend = false;
          this.phoneCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.phoneCodeStatus.times--;
        }
      }, 1000);
      this.$axios.post("/sendCode/send", this.phoneCodeSend).then((res) => {
        if (res.data.code === this.errorCode.ok) {
          this.bindData.phoneToken = res.data.data.token;
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    hasSendEmailCode() {
      let emailValidate = true;
      this.$refs.ruleFormEmailBind.validate((va, op) => {
        if (op.email) {
          //邮箱验证是否通过
          emailValidate = false;
        }
      });
      if (!emailValidate) {
        return;
      }
      this.emailCodeSend.email = this.bindData.email;
      this.emailCodeStatus.hasSend = true;
      let timer = setInterval(() => {
        if (this.emailCodeStatus.times <= 0) {
          this.emailCodeStatus.hasSend = false;
          this.emailCodeStatus.times = 60;
          clearInterval(timer);
        } else {
          this.emailCodeStatus.times--;
        }
      }, 1000);
      this.$axios
        .post("/user/sendSecurityCode", this.emailCodeSend)
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.bindData.emailToken = res.data.data.token;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    submit() {
      let ref = this.$refs.ruleFormEmailBind;
      ref.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.$axios.post("/user/bindSecurity", this.bindData).then((res) => {
            if (res.data.code === this.errorCode.ok) {
              this.elMessage("success", this.$t("email_bind.success"));
              this.$store.dispatch("actions_getUserInfo").then((res) => {
                this.dialogVisible = false;
              });
            } else {
              this.elMessage("error", res.data.msg);
            }
          });
        }
      });
    },
    dialogClose() {
      this.$refs.ruleFormEmailBind.resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  width: 540px;
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__header {
    padding: 0;
  }
  .el-dialog__body {
    padding: 32px 30px;
  }
  .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #333333;
  }

  .el-input__suffix,
  .el-input__suffix-inner {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .el-input-group--append {
    gap: 16px;
    display: flex;
  }
  .el-input__inner {
    height: 60px;
    border-radius: 8px 8px 8px 8px;
  }
  .el-input-group__append {
    cursor: pointer;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #4063ff;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #4063ff;
    padding: 0 24px;
    width: auto;
    display: flex;
    align-items: center;
  }
  .el-form-item {
    margin-bottom: 8px;
  }
}
.mt8 {
  margin-top: 8px;
}
.p1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 36px;
  color: #333333;
}
.p2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 18px;
  color: #333333;
}
.p3 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
}
.sp1 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
}
.sp2 {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 32px;
  color: #4063ff;
}
.box1 {
  width: 480px;
  height: 160px;
  overflow: hidden;
  padding-left: 20px;
  background: #ffffff;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 12px 12px 12px 12px;
  background-image: url(~@/assets/img/images/member-bj.png);
}
.close-img {
  width: 14px;
  height: 14px;
  top: 20px;
  right: 20px;
  cursor: pointer;
  position: absolute;
}
.btn-box {
  gap: 10px;
  display: flex;
  margin-top: 32px;
  .btn1 {
    flex: 1;
    cursor: pointer;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #4063ff;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #4063ff;
  }
  .btn2 {
    flex: 1;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: #3370ff;
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #ffffff;
  }
}
</style>
